






























import { Component, Vue, Prop } from 'vue-property-decorator';
import moment, {Moment} from 'moment';

@Component
export default class CopyTodoModal extends Vue {
  @Prop({required: true}) private disabledDateValue!: string;
  @Prop({required: true}) private todo!: ITodo.IResponse.ITodoInfo;
  @Prop({default: true}) private disabled!: boolean;
  private visible = false;
  private checkBoxDates: Moment[] = [];
  get checkedDates() {
    return this.checkBoxDates.map((item) => item.format('YYYY/MM/DD'));
  }
  public showModal() {
    this.visible = true;
    this.checkBoxDates = [];
  }
  public closeModal() {
    this.visible = false;
  }
  private disabledDate(current: Moment) {
    let endDate = moment().endOf('year');
    const startDate = moment().startOf('day');
    if (this.disabledDateValue) {
      endDate = moment(this.disabledDateValue).endOf('day');
    }
    return current && (current < startDate || current > endDate);
  }
  private duesChange(e: Event | any, date: Moment) {
    let newDates: Moment[] = [];
    if (e.target.checked) {
      newDates = [...this.checkBoxDates];
      newDates.push(date);
    } else {
      newDates = this.checkBoxDates.filter((item) => item.format('YYYY-MM-DD') !== date.format('YYYY-MM-DD'));
    }
    newDates.sort((a, b) => {
      return a.valueOf() - b.valueOf();
    });
    this.checkBoxDates = [...newDates];
  }
  private handleBatchCopyTodo() {
    this.$emit('batch-copy', {todo: this.todo, dates: this.checkBoxDates});
    this.closeModal();
  }
}
